import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { apiGet, ChecklistSummary } from './api';

const ChecklistsList: React.FC = () => {
  const { sessionToken } = useAuth();
  const [items, setItems] = useState<ChecklistSummary[]>([]);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await apiGet<{ checklists: ChecklistSummary[] }>('/checklists', sessionToken);
        setItems(data.checklists);
      } catch (e: any) { setErr(e.message); } finally { setLoading(false); }
    })();
  }, [sessionToken]);

  return (
    <div>
      <h2>Checklists</h2>
      {err && <div className="error-banner">{err}</div>}
      {loading && <p role="status">Loading checklists…</p>}
      {!loading && items.length === 0 && !err && <p>No checklists yet.</p>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '0.75rem' }}>
        {items.map((t) => (
          <Link
            key={t.id}
            to={`/checklists/${t.slug}`}
            style={{
              display: 'block',
              padding: '1rem',
              border: '1px solid #ddd',
              borderRadius: 6,
              textDecoration: 'none',
              color: 'inherit',
              background: '#fff',
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: 4 }}>{t.name}</div>
            <div style={{ fontSize: '0.85em', color: '#666' }}>
              {t.frequency} · {t.item_count} item{t.item_count === 1 ? '' : 's'} in {t.section_count} section{t.section_count === 1 ? '' : 's'}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ChecklistsList;
